"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffTable = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const Cell_1 = require("./Cell");
require("./index.scss");
exports.className = 'tariff-table';
/** @deprecated Use TariffsTable */
const TariffTable = (props) => {
    const [headRow, ...bodyRows] = props.rows;
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${exports.className}__row`, 'head') }, headRow.map((cell, id) => (react_1.default.createElement(Cell_1.TariffTableRowCell, { cell: cell, key: id })))),
        bodyRows.map((rowElement, idx) => (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${exports.className}__row`, 'body'), key: idx }, rowElement === null || rowElement === void 0 ? void 0 : rowElement.map((cell, id) => (react_1.default.createElement(Cell_1.TariffTableRowCell, { cell: cell, key: id }))))))));
};
exports.TariffTable = TariffTable;
//# sourceMappingURL=index.js.map